import { Link } from 'react-router-dom';
import { works } from '@/mocks/works';
import WorkCard from '@/components/base/WorkCard';

const latest = [...works].sort((a, b) => (a.uploadTime < b.uploadTime ? 1 : -1)).slice(0, 8);

export default function LatestWorks() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-100">
      <div className="flex items-center justify-between mb-6 md:mb-8">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">最新上传作品</h2>
        <Link to="/category/creative" className="text-sm text-primary-600 hover:text-primary-700 cursor-pointer whitespace-nowrap">
          查看更多 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
        {latest.map((w) => (
          <WorkCard key={w.id} work={w} />
        ))}
      </div>
    </section>
  );
}